import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { useLocales } from "src/locales";

// ----------------------------------------------------------------------

export default function SearchNotFound({ query, sx, ...other }) {
  const { t } = useLocales();

  return query ? (
    <Paper
      sx={{
        bgcolor: "unset",
        textAlign: "center",
        ...sx,
      }}
      {...other}
    >
      <Typography
        variant="h6"
        gutterBottom
      >
        {t("searchNotFoundTitle")}
      </Typography>

      <Typography variant="body2">
        {t("searchNotFoundFor", { query })}
        <br /> {t("searchNotFoundHint")}
      </Typography>
    </Paper>
  ) : (
    <Typography
      variant="body2"
      sx={sx}
    >
      {t("searchEnterKeywords")}
    </Typography>
  );
}

SearchNotFound.propTypes = {
  query: PropTypes.string,
  sx: PropTypes.object,
};
